<template>
  <div>
    <el-form ref="form" v-if="search">
      <el-form-item style="margin-bottom: 0px">
        <div style="display: flex; display: flex; align-items: center; gap: 10px">
          <el-input
            style="width: 100%"
            placeholder="Buscar..."
            size="small"
            prefix-icon="el-icon-search"
            v-model="searchQuery"
            name="buscador"
          ></el-input>
          <el-tooltip :content="filteredData.length + ' resultados'">
            <el-button type="success" size="small"
              ><i class="el-icon-s-data" /> {{ filteredData.length }}</el-button
            ></el-tooltip
          >
        </div>
      </el-form-item>
    </el-form>

    <el-tooltip
      v-if="multipleSelection.length > 0 && draggable"
      class="item"
      effect="dark"
      content="Ordenar contenido"
      placement="top-start"
    >
      <el-button @click="handleSorteableMultiple()">
        <i class="el-icon-sort"></i>
      </el-button>
    </el-tooltip>
    <el-tooltip
      v-if="multipleSelection.length > 0 && desktop"
      class="item"
      effect="dark"
      content="Añadir como escritorio"
      placement="top-start"
    >
      <el-button type="primary" @click="handleDesktop(1)">
        <i class="el-icon-circle-plus-outline"></i>
      </el-button>
    </el-tooltip>
    <el-tooltip
      v-if="multipleSelection.length > 0 && desktop"
      class="item"
      effect="dark"
      content="Eliminar como escritorio"
      placement="top-start"
    >
      <el-button type="danger" @click="handleDesktop(0)">
        <i class="el-icon-remove-outline"></i>
      </el-button>
    </el-tooltip>
    <el-tooltip
      v-if="multipleSelection.length > 0"
      class="item"
      effect="dark"
      content="Eliminación múltiple"
      placement="top-start"
    >
      <el-button type="danger" @click="handleDeleteMultiple()">
        <i class="el-icon-delete"></i>
      </el-button>
    </el-tooltip>

    <el-table
      :height="windowHeight - 170"
      class="custom-table"
      :data="paginatedData"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      :default-sort="default_sort"
      empty-text="No hay datos en esta sección."
    >
      <el-table-column type="expand" v-if="expand">
        <template slot-scope="props">
          <el-table :data="props.row[expandData]">
            <el-table-column
              v-if="c.prop === 'acces_date'"
              v-for="(c, i) in expandColumns"
              :key="i"
              :prop="c.prop"
              :label="c.label"
            >
              <template slot-scope="scope" v-if="scope.row[c.prop]">
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success">
                    <i class="el-icon-time"></i>
                    {{ scope.row[c.prop] }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-if="
                c.prop !== 'acces_date' &&
                !path(c.prop) &&
                !date(c.prop) &&
                c.prop !== 'read' &&
                c.prop !== 'comprendido' &&
                c.type != 'date'
              "
              v-for="(c, i) in expandColumns"
              :key="i"
              :prop="c.prop"
              :label="c.label"
            ></el-table-column>

            <el-table-column
              v-if="path(c.prop)"
              v-for="(c, i) in expandColumns"
              :key="i"
              :prop="c.prop"
              :label="c.label"
              sortable
              :filters="filterColumn[c.prop]"
              :filter-method="filterHandler"
            >
              <template slot-scope="scope" v-if="scope.row[c.prop]">
                <div slot="reference" class="name-wrapper">
                  <a :href="scope.row[c.prop]" target="_blank">
                    <el-tag type="warning">{{ scope.row[c.prop] }}</el-tag>
                  </a>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="115"
              v-if="c.prop === 'read'"
              v-for="(c, i) in expandColumns"
              :key="i"
              :prop="c.prop"
              :label="c.label"
              sortable
            >
              <template slot-scope="scope" v-if="scope.row[c.prop]">
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" v-if="scope.row[c.prop] === 1">Sí</el-tag>
                  <el-tag type="danger" v-else-if="(scope.row[c.prop] = 2)">No</el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              width="115"
              v-if="c.prop === 'comprendido'"
              v-for="(c, i) in expandColumns"
              :key="i"
              :prop="c.prop"
              :label="c.label"
              sortable
            >
              <template slot-scope="scope" v-if="scope.row[c.prop]">
                <div slot="reference" class="name-wrapper">
                  <el-tag type="success" v-if="scope.row[c.prop] === 1">Sí</el-tag>
                  <el-tag type="danger" v-else-if="(scope.row[c.prop] = 2)">No</el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-for="(c, i) in expandColumns"
              :key="i"
              :prop="c.prop"
              :label="c.label"
              v-if="date(c.prop) || c.type === 'date'"
            >
              <template slot-scope="scope" v-if="scope.row[c.prop]">
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">
                    <i class="fa fa-calendar"></i>
                    {{ scope.row[c.prop] | moment }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Acciones"
              fixed="right"
              width="100"
              v-if="expand && displayAccionesExpandTable"
            >
              <template slot-scope="scope">
                <el-tooltip
                  v-if="previewModal"
                  class="item"
                  effect="dark"
                  content="Visualizar contenido extra"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                    type="info"
                    @click="handlePreviewModal(scope.row.id)"
                  >
                    <i class="el-icon-view"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column
        type="selection"
        width="55"
        v-if="!expand && selection != 'no'"
      ></el-table-column>

      <el-table-column
        width="80"
        v-for="(c, i) in tableColumns"
        :key="i * 10000"
        :prop="c.prop"
        :label="c.label"
        v-if="c.label == 'Icono'"
      >
        <template slot-scope="scope">
          <span :class="'icono ' + scope.row.icon">
            <span class="icono path1"></span>
            <span class="icono path2"></span>
            <span class="icono path3"></span>
            <span class="icono path4"></span>
            <span class="icono path5"></span>
            <span class="icono path6"></span>
            <span class="icono path7"></span>
            <span class="icono path8"></span>
            <span class="icono path9"></span>
            <span class="icono path10"></span>
            <span class="icono path11"></span>
            <span class="icono path12"></span>
            <span class="icono path13"></span>
            <span class="icono path14"></span>
            <span class="icono path15"></span>
          </span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="
          c.type != 'file' &&
          c.label != 'Imagen' &&
          c.label != 'Icono' &&
          c.label != 'Permisos' &&
          date(c.prop) == false &&
          c.label != 'Submenu' &&
          c.prop !== 'read' &&
          !path(c.prop) &&
          c.type != 'switch' &&
          c.prop !== 'comprendido' &&
          c.type !== 'date' && c.type !== 'datemonth'
        "
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        :width="c.prop == 'id' ? '100px' : 'auto'"
        sortable
        :filters="filterColumn[c.prop]"
        :filter-method="filterHandler"
      ></el-table-column>

      <el-table-column
        v-for="(c, i) in tableColumns"
        :key="i * 50000"
        :prop="c.prop"
        :label="c.label"
        v-if="c.label == 'Imagen'"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.url ? checkUrl(scope.row.url) : api_uploads + scope.row.image"
            alt
            width="80px"
          />
        </template>
      </el-table-column>

      <el-table-column
        v-for="(c, i) in tableColumns"
        :key="i * 50000"
        :prop="c.prop"
        :label="c.label"
        :width="120"
        align="center"
        v-if="c.type == 'file'"
      >
        <template slot-scope="scope">
          <el-link
            style="font-size: 25px"
            icon="el-icon-document"
            :underline="false"
            :href="
              scope.row[c.prop]
                ? checkUrl(scope.row[c.prop])
                : api_uploads + scope.row[c.prop]
            "
            target="_blank"
            v-if="scope.row[c.prop]"
          ></el-link>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        v-if="c.type == 'switch'"
        sortable
      >
        <template slot-scope="scope" v-if="scope.row[c.prop]">
          <div slot="reference" class="name-wrapper">
            <el-tag type="success" v-if="scope.row[c.prop] == '1'">Sí</el-tag>
            <el-tag type="danger" v-else-if="scope.row[c.prop] == '2'">No</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="c.label == 'Permisos'"
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        sortable
        :filters="filterColumn['auth']"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper" v-if="scope.row.auth">
            <el-tag size="medium">
              <i class="fa fa-lock"></i>
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-if="c.label == 'Submenu'"
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        sortable
        :filters="filterColumn['submenu']"
        :filter-method="filterHandler"
      >
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper" v-if="scope.row.submenu">
            <el-tag size="medium">{{ scope.row[c.prop] }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        width="110"
        v-if="c.prop === 'read'"
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        sortable
      >
        <template slot-scope="scope" v-if="scope.row[c.prop]">
          <div slot="reference" class="name-wrapper">
            <el-tag type="success" v-if="scope.row[c.prop] === 1">Sí</el-tag>
            <el-tag type="danger" v-else-if="scope.row[c.prop] === 2">No</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        v-if="c.prop === 'comprendido'"
        v-for="(c, i) in tableColumns"
        :key="'c' + i"
        :prop="c.prop"
        :label="c.label"
        sortable
      >
        <template slot-scope="scope" v-if="scope.row[c.prop]">
          <div slot="reference" class="name-wrapper">
            <el-tag type="success" v-if="scope.row[c.prop] === 1">Sí</el-tag>
            <el-tag type="danger" v-else-if="scope.row[c.prop] === 2">No</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        v-if="(date(c.prop) || c.type === 'date') && !['datemonth'].includes(c.type)"
        sortable
      >
        <template slot-scope="scope" v-if="scope.row[c.prop]">
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium">
              <i class="fa fa-calendar"></i>
              {{ scope.row[c.prop] | moment }}
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(c, i) in tableColumns"
        :key="i"
        :prop="c.prop"
        :label="c.label"
        v-if="date(c.prop) || c.type === 'datemonth'"
        sortable
      >
        <template slot-scope="scope" v-if="scope.row[c.prop]">
          <div slot="reference" class="name-wrapper">
            <el-tag size="medium">
              <i class="fa fa-calendar"></i>
              {{ scope.row[c.prop] | momentMonth }}
            </el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        label="Acciones"
        fixed="right"
        width="375"
        v-if="!noDisplayActions"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="editAjax"
            class="item"
            effect="dark"
            content="Editar contenido"
            placement="top-start"
          >
            <el-button size="mini" @click="handleEditAjax(scope.$index, scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="routeEdit"
            class="item"
            effect="dark"
            content="Editar contenido"
            placement="top-start"
          >
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">
              <i class="el-icon-edit"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="routeDelete != 'no'"
            class="item"
            effect="dark"
            content="Eliminar contenido"
            placement="top-start"
          >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >
              <i class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="preview && previewCustom"
            class="item"
            effect="dark"
            content="Visualizar contenido en la intranet"
            placement="top-start"
          >
            <el-button
              size="mini"
              type="info"
              @click="handlePreviewCustom(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="preview && !previewCustom"
            class="item"
            effect="dark"
            content="Visualizar contenido en la intranet"
            placement="top-start"
          >
            <el-button
              size="mini"
              type="info"
              @click="handlePreview(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="previewHistory"
            class="item"
            effect="dark"
            content="Visualizar contenido en la intranet"
            placement="top-start"
          >
            <el-button
              size="mini"
              type="info"
              @click="handleHistory(scope.$index, scope.row)"
            >
              <i class="el-icon-view"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="link"
            class="item"
            effect="dark"
            content="Añadir secciones dentro de este elemento"
            placement="top-start"
          >
            <el-button
              size="mini"
              type="info"
              @click="handleLink(scope.$index, scope.row)"
            >
              <i class="el-icon-more"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="duplicate"
            class="item"
            effect="dark"
            content="Duplicar contenido"
            placement="top-start"
          >
            <el-button size="mini" type="primary" @click="handleDuplicate(scope.row)">
              <i class="fa fa-copy"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip
            v-if="move && !scope.row.submenu"
            class="item"
            effect="dark"
            content="Mover"
            placement="top-start"
          >
            <el-button size="mini" type="warning" @click="handleMove(scope.row)">
              <i class="el-icon-setting"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip
            v-if="customBtn"
            class="item"
            effect="dark"
            :content="customBtn.nombre"
            placement="top-start"
          >
            <el-button size="mini" type="warning" @click="handleCustomBtn(scope.row)">
              <i :class="customBtn.icon"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <template v-if="tableShow">
      <div style="display: flex; margin-top: 10px; justify-content: space-between">
        <el-pagination
          v-if="filteredData.length > itemsPorPagina"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="itemsPorPagina"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filteredData.length"
        ></el-pagination>
        <slot name="cutom_button"></slot>
      </div>
    </template>
  </div>
</template>

<script>
import { API_UPLOADS } from "@/common/config";
import moment from "moment-timezone";

export default {
  name: "tablaConPaginador",
  props: [
    "routeEdit", // ruta para botón editar
    "tableQuery", // datos de la tabla
    "tableColumns", // datos thead tabla
    "routeDelete", // ruta para eliminar
    "preview", // Ruta para previsualizar
    "previewCustom",
    "previewHistory",
    "desktop", // Mostar botones para añadir / quitar escritorio
    "draggable", // Modal para ordenar orden en tabla (order_row -> nombre de la fila en bd)
    "limit", // Cambia el límite predeterminado de 10
    "paramEdit", // Por defecto la url para editar apunta al id, con este parámetro podemos cambiar el id por otro campo de la bd
    "deleteRow", // Por defecto la url para eliminar apunta al id, con este parámetro podemos cambiar el id por otro campo de la bd
    "search", // Activa el buscador,
    "link", // Enlazar contenido dentro de otro contenido
    "noDisplayActions", // Si es true, no muestra la columna de opciones (ver, editar, borrar...)
    "expand",
    "expandData",
    "expandColumns",
    "selection",
    "duplicate",
    "move",
    "editAjax",
    "default_sort",
    "previewModal",
    "displayAccionesExpandTable",
    "customBtn",
    "table",
  ],
  created() {
    this.$root.$on("updateData", (e) => (e = this.searchInTable()));
    this.init();
  },
  beforeDestroy() {
    this.$root.$off("updateData", (e) => (e = this.searchInTable()));
  },
  watch: {
    searchQuery(v, a) {
      this.searchInTable();
    },
  },
  computed: {},
  data() {
    return {
      currentPage: 1,
      totalRegistros: null,
      itemsPorPagina: 50,
      filteredData: [],
      paginatedData: [],
      row: null,
      multipleSelection: false,
      api_uploads: API_UPLOADS,
      pagesizes: [10, 20, 30, 40, 50, 100, this.tableQuery.length],
      editRow: "id",
      delRow: "id",
      searchQuery: "",
      tableShow: false,
      filterColumn: [],
      fechas: [
        "date",
        "filed",
        "accepted",
        "implemented",
        "rejected",
        "startdate",
        "enddate",
        "last_access",
      ],
      rutas: ["path", "url", "link"],
      windowHeight: window.innerHeight,
    };
  },
  methods: {
    async init() {
      this.limit ? (this.itemsPorPagina = this.limit) : (this.itemsPorPagina = 50);
      this.paramEdit ? (this.editRow = this.paramEdit) : false;
      this.deleteRow ? (this.delRow = this.deleteRow) : false;

      await this.searchInTable();

      this.tableColumns.forEach((e) => {
        this.filter(e.prop);
      });

      this.tableShow = true;
    },
    paginador() {
      this.paginatedData = this.filteredData.slice(
        (this.currentPage - 1) * this.itemsPorPagina,
        this.currentPage * this.itemsPorPagina
      );
    },
    handlePreviewModal(val) {
      this.$root.$emit("TableModal", val);
    },
    handleSizeChange(val) {
      this.itemsPorPagina = val;
      this.searchInTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchInTable();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEditAjax(index, row) {
      this.$root.$emit("editAjax", row);
    },
    handleEdit(index, row) {
      if (this.routeEdit != "modal") {
        row.templateId
          ? this.$router.push(this.routeEdit + row[this.editRow] + "/" + row.templateId)
          : this.$router.push(this.routeEdit + row[this.editRow]);
      } else {
        this.$root.$emit("openModal", row[this.editRow]);
      }
    },
    handleDelete(index, row) {
      this.$confirm(
        "Esto eliminará permanentemente el registro. ¿Continuar?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          if (this.routeDelete == "galeriaImagenes") {
            this.$root.$emit("galeriaImagenes", row[this.delRow], row);
          } else if (this.routeDelete == "fichas_archivosficha") {
            this.$root.$emit("delete_fichas_archivosficha", row[this.delRow], row);
          } else if (this.routeDelete) {
            this.$root.$emit(this.routeDelete, row[this.delRow], row);
          } else if (this.editAjax) {
            this.$root.$emit(
              "delete",
              {
                row: row[this.delRow],
                table: this.table,
              },
              row
            );
          } else {
            this.$root.$emit("delete", row[this.delRow], row);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Se ha cancelado el borrado",
          });
        });
    },
    handleSorteableMultiple() {
      this.$root.$emit("draggable");
    },
    handleLink(index, row) {
      this.$root.$emit("link-content", row.id);
    },
    handleDeleteMultiple() {
      this.$confirm(
        "Esto eliminará permanentemente los registros marcados. ¿Continuar?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          if (this.routeDelete) {
            this.multipleSelection.forEach((element) => {
              this.$root.$emit(this.routeDelete, element.id, element);
            });
          } else if (this.editAjax) {
            this.multipleSelection.forEach((element) => {
              this.$root.$emit(
                "delete",
                {
                  row: element.id,
                  table: this.table,
                },
                element
              );
            });
          } else {
            this.multipleSelection.forEach((element) => {
              this.$root.$emit("delete", element.id, element);
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Se ha cancelado el borrado",
          });
        });
    },
    handleDesktop(value) {
      this.multipleSelection.forEach((element) => {
        this.$root.$emit("desktop", element.id, element, value);
      });
    },
    handlePreview(index, row) {
      window.open(this.preview + row.url, "_blank");
    },
    handleHistory(index, row) {
      window.open(this.previewHistory + row.id, "_blank");
    },
    handlePreviewCustom(index, row) {
      window.open(this.preview + row[this.previewCustom], "_blank");
    },
    handleDuplicate(row) {
      this.$root.$emit("duplicate", row);
    },
    handleMove(row) {
      window.open(row.move + "?hide=1", "_blank");
    },
    handleCustomBtn(row) {
      this.$root.$emit("customBtn", row);
    },
    createFilter(prop) {
      let b = [];
      let filter = this.tableQuery.map((data) => {
        let c = {
          text: data[prop],
          value: data[prop],
        };
        return b.push(c);
      });
      return b;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    searchInTable() {
      if (this.searchQuery) {
        this.filteredData = this.tableQuery.filter((e) => {
          return this.tableColumns.some((p) => {
            if (e[p.prop] != null && typeof e[p.prop] === "string" && e[p.prop]) {
              return e[p.prop]
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .includes(
                  this.searchQuery
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                );
            }
          });
        });
      } else {
        this.filteredData = [...this.tableQuery];
      }
      this.paginador();
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    filter(prop) {
      if (Array.isArray(this.tableQuery)) {
        let f = this.tableQuery.map((e) => {
          return e[prop];
        });
        let u = f.filter(function (v, i, a) {
          return i == a.indexOf(v);
        });
        let a = u.map((e) => {
          return { text: e, value: e };
        });
        this.filterColumn[prop] = a;
      }
    },

    date(value) {
      return this.fechas.includes(value);
    },
    path(value) {
      return this.rutas.includes(value);
    },
    checkUrl(url) {
      let pattern = /^(http|https)\:\/\/[a-z0-9\.-]+\.[a-z]{2,4}/gi;
      return url.match(pattern) ? url : this.api_uploads + url;
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).tz("Europe/Madrid").format("DD/MM/Y");
    },
    momentMonth: function (date) {
      return moment(date).tz("Europe/Madrid").format("MM/Y");
    },
  },
};
</script>

<style scoped>
.fa {
  font-size: 14px;
  padding: 0;
  width: auto;
  margin: 0;
}
.icono {
  font-size: 25px;
}
.w-80px {
  width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/_commons/tablaConPaginador.vue